<svg class="icon-context max-width-init" [class.active]="isActive" xmlns="http://www.w3.org/2000/svg" width="16" height="16"
    viewBox="0 0 16 16" fill="none">
    <path
        d="M1.5 4.5C1.5 3.94771 1.94772 3.5 2.5 3.5H4.5H5C5.55228 3.5 6 3.05228 6 2.5V2.5C6 1.94772 6.44772 1.5 7 1.5H9C9.55228 1.5 10 1.94772 10 2.5V2.5C10 3.05228 10.4477 3.5 11 3.5H11.5H13.5C14.0523 3.5 14.5 3.94772 14.5 4.5V13.5C14.5 14.0523 14.0523 14.5 13.5 14.5H2.5C1.94772 14.5 1.5 14.0523 1.5 13.5V4.5Z"
        stroke="var(--text-color-dark)" />
    <path d="M4.5 3V4.5C4.5 5.05228 4.94772 5.5 5.5 5.5H10.5C11.0523 5.5 11.5 5.05228 11.5 4.5V3"
        stroke="var(--text-color-dark)" />
</svg>
